<template lang="pug">
    div.icon-toggle-control(:class="theClass" @click="click")
        svg-icon(:iconId="iconId")
</template>

<script>
export default {
    name: 'icon-toggle-control',
    props: {
        value: {
            type: Boolean,
            required: true,
        },
        iconId: {
            type: String,
            required: true,
        },
    },
    computed: {
        model: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            },
        },
        theClass() {
            return {
                'icon-toggle-control--on': this.model,
            }
        },
    },
    methods: {
        click() {
            this.model = !this.model
        },
    },
}
</script>
